var path = 'areas/shared/views/selector/match-release.html';
var html = "<span ng-if=\"$item.Version == null\" class=deleted uib-tooltip=\"The version referenced by this record ({{$item}}) no longer exists and should be removed before saving. Please let Octopus support know so that we can prevent this from happening in future.\"><i class=\"fa fa-warning\"></i> Missing</span> <span ng-if=\"$item.Version != null\">{{$item.Version}}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/match-release.html
// module id = 769435652536019
// module chunks = 1